// src/private/ConfirmDialog.jsx
import React from "react";
import { useT } from "../i18n/LanguageContext";
import "./ConfirmDialog.css";

// In-app replacement for window.confirm() — the native dialog breaks the
// glass/gradient app chrome. Controlled: caller owns the open condition and
// both button callbacks.
export default function ConfirmDialog({
  open,
  title,
  message,
  confirmLabel,
  cancelLabel,
  onConfirm,
  onCancel,
}) {
  const t = useT();
  if (!open) return null;
  const resolvedConfirm = confirmLabel || t('canvas.confirmDialog.confirm');
  const resolvedCancel = cancelLabel || t('canvas.confirmDialog.cancel');
  return (
    <div className="confirm-dialog-backdrop" onClick={onCancel}>
      <div className="confirm-dialog" onClick={(e) => e.stopPropagation()}>
        {title && <div className="confirm-dialog__title">{title}</div>}
        <p className="confirm-dialog__message">{message}</p>
        <div className="confirm-dialog__actions">
          <button type="button" className="confirm-dialog__btn confirm-dialog__btn--cancel" onClick={onCancel}>
            {resolvedCancel}
          </button>
          <button type="button" className="confirm-dialog__btn confirm-dialog__btn--confirm" onClick={onConfirm}>
            {resolvedConfirm}
          </button>
        </div>
      </div>
    </div>
  );
}
